<section #parentElement class="filters-card" dir="rtl" aria-label="מסנני חיפוש">
  <div class="filters-header">
    <div class="filters-heading">
      <span class="filters-icon" aria-hidden="true"><mat-icon>tune</mat-icon></span>
      <div>
        <h2>סינון תוצאות</h2>
        <p>בחרו את המאפיינים שמתאימים לכם</p>
      </div>
    </div>

    <button
      type="button"
      class="advanced-toggle"
      (click)="openAdvancedSearch()"
      [attr.aria-expanded]="advancedSearch">
      <mat-icon aria-hidden="true">tune</mat-icon>
      <span>{{ 'sale4you.label.advancedSearch' | translate }}</span>
      <mat-icon class="toggle-chevron" [class.is-open]="advancedSearch" aria-hidden="true">expand_more</mat-icon>
    </button>
  </div>

  <div class="filters-content">
    @if (activeFilters.length > 0) {
      <div class="active-filters" aria-label="מסננים פעילים">
        <span class="active-filters-label">מסננים פעילים</span>
        <div class="filter-chips">
          @for (filter of activeFilters; track filter.key) {
            <button type="button" class="filter-chip" (click)="removeFilter(filter.key)" [attr.aria-label]="'הסר ' + filter.label">
              <span class="chip-label">{{ filter.label }}:</span><span>{{ filter.value }}</span><mat-icon>close</mat-icon>
            </button>
          }
        </div>
        <button type="button" class="clear-all" (click)="clearAllFilters()">נקה הכול</button>
      </div>
    }
    <div class="filters-grid">
      @for (filterBase of filterBaseService.filterBases | sortBy:'order' | filterBasesFilter:'advanced':false; track filterBase) {
        <div class="field-box">
          <app-filter-base [filterBoxWidth]="filterBoxWidth" [filterBase]="filterBase"></app-filter-base>
        </div>
      }
    </div>

    @if (advancedSearch) {
      <div class="advanced-fields">
        <div class="advanced-divider"><span>אפשרויות נוספות</span></div>
        <div class="filters-grid filters-grid--advanced">
          @for (filterBase of filterBaseService.filterBases | sortBy:'order' | filterBasesFilter:'advanced':true; track filterBase) {
            <div class="field-box" [ngClass]="getRequiredClass(filterBase)">
              <app-filter-base [filterBoxWidth]="filterBoxWidth" [filterBase]="filterBase"></app-filter-base>
            </div>
          }
        </div>
      </div>
    }

    <div class="filters-actions">
      <button type="button" class="search-button" (click)="searchApply()">
        <mat-icon aria-hidden="true">search</mat-icon>
        <span>{{ 'sale4you.label.search' | translate }}</span>
      </button>
    </div>
  </div>
</section>
